import { environment } from '../../environments/environment';

export const API_URLS = {
    LIST_OF_COUNTRIES: environment.apiUrl + '/countries',
    LIST_OF_BUSINESS_TYPES: environment.apiUrl + '/businessTypes',
    LIST_OF_PRODUCT_CATEGORIES: environment.apiUrl + '/product_categories',
    REGISTER: environment.apiUrl + '/oauth/register',
    CHECK_TOKEN: environment.apiUrl + '/oauth/check_token',
    LOGIN: environment.apiUrl + '/oauth/token',
    LOGOUT: environment.apiUrl + '/oauth/logout',
    REFRESH_TOKEN: environment.apiUrl + '/oauth/refreshToken',
    LINE_OFFERS_BASE_URL: environment.apiUrl + '/lineOffers',
    DELIVERY_REQUESTS_BASE_URL: environment.apiUrl + '/deliveryRequests',
    LOAD_CURRENT_USER_DETAILS: environment.apiUrl + '/user',
    USERS_BASE_PATH: environment.apiUrl + '/users/',
    CREATE_PRIVATE_SELLER_ACCOUNT: environment.apiUrl + '/user',
    CREATE_DELIVERY_AGENT: environment.apiUrl + '/user',
    CREATE_LOGISTIC_COMPANY: environment.apiUrl + '/user',
    GET_CARRIER_DETAILS: environment.apiUrl + '/user',
    GET_SELLER_ACCOUNT: environment.apiUrl + '/user',
    REQUEST_PHONE_VERIFICATION_CODE: environment.apiUrl + '/user',
    VALIDATE_VERIFICATION_CODE: environment.apiUrl + '/user',
    UPDATE_PRIVATE_SELLER_ACCOUNT: environment.apiUrl + '/user',
    CREATE_COMPANY_SELLER_ACCOUNT: environment.apiUrl + '/user',
    UPDATE_COMPANY_SELLER_ACCOUNT: environment.apiUrl + '/user',
    COMPLETE_SELLER_ACCOUNT: environment.apiUrl + '/user',
    COMPLETE_CARRIER_ACCOUNT: environment.apiUrl + '/user',
    UPDATE_LOGISTIC_AGENT: environment.apiUrl + '/user',
    UPDATE_LOGISTIC_COMPANY: environment.apiUrl + '/user',
    FORGET_PASSWORD: environment.apiUrl + '/oauth/password-reset/request-token',
    PASSWORD_VERIFY_TOKEN: environment.apiUrl + '/oauth/password-reset/verify-token',
    VERIFY_SIGN_UP_TOKEN: environment.apiUrl + '/oauth/verify_token',
    UPDATE_PASSWORD: environment.apiUrl + '/oauth/password-reset/update-password',
    PRODUCT_CATEGORIES_API: environment.apiUrl + '/secure/product_categories',
    LIST_OF_USERS: environment.apiUrl + '/secure/users',
    LIST_OF_PRODUCTS: environment.apiUrl + '/secure/products',
    LIST_OF_SECTORS: environment.apiUrl + '/sectors',
    LIST_OF_PRICING: environment.apiUrl + '/pricing',
    LIST_OF_PRODUCTS_CONDITIONS: environment.apiUrl + '/product_conditions',
    LIST_OF_MEASUREMENT: environment.apiUrl + '/measurement_units',
    MEDIA_BASE_URL: environment.apiUrl + '/media',
    OFFERS_BASE_URL: environment.apiUrl + '/offers',
    RELATED_OFFERS_BASE_URL: environment.apiUrl + '/relatedOffers',
    SEARCH_URL: environment.apiUrl + '/search',
    LIST_OF_PAYMENT_METHODS: environment.apiUrl + '/payment_methods',
    PAYMENT_METHODS_BASE_URL: environment.apiUrl + '/secure/payment_methods',
    SHIPPING_MEANS_BASE_URL: environment.apiUrl + '/secure/shipping_means',
    SHIPPING_MEANS_UNAUTHENTICATED_BASE_URL: environment.apiUrl + '/shipping_means',
    SHIPPING_TYPES_BASE_URL: environment.apiUrl + '/shipping_types',
    SHIPPING_OPTIONS_BASE_URL: environment.apiUrl + '/shippingOptions',
    SHIPPING_PRICING_BASE_URL: environment.apiUrl + '/shippingPricing',
    CITIES_BASE_URL: environment.apiUrl + '/cities',
    PAYMENTS_BASE_URL: environment.apiUrl + '/payments',
    INIT_SUBSCRIPTION_PAYMENT: environment.apiUrl + '/payments/init-payment',
    CONFIRM_SUBSCRIPTION_PAYMENT: environment.apiUrl + '/payments/confirm-payment',
    BLOG_BASE_URL: environment.apiUrl + '/blog',
    ADMIN_PAGES_BASE_URL: environment.apiUrl + '/secure/pages',
    SINGLE_PAGE_BASE_PATH: environment.apiUrl + '/pages',
    CONTACT_US_MAIL_API: environment.apiUrl + '/contact-us/send-mail',
    TEAM_BASE_PATH: environment.apiUrl + '/team_member',
    TAXONOMY_URL: environment.apiUrl + '/taxonomies',
    SECURE_TEAM_BASE_PATH: environment.apiUrl + '/secure/team_member',
    SECURE_REQUESTED_PRODUCTS_BASE_PATH: environment.apiUrl + '/secure/request_products',
    SINGLE_PRICING: environment.apiUrl + '/secure/pricing',
    SINGLE_SECTOR_API: environment.apiUrl + '/secure/sectors',
    NEWSLETTER_URL: environment.apiUrl + '/subscriptions',
    LIST_OF_PACKAGES: environment.apiUrl + '/packages',
    GET_USER_SUBSCRIPTION: environment.apiUrl + '/user/subscription',
    GET_SUBSCRIPTIONS: environment.apiUrl + '/subscriptions',
    JOBS_URL: environment.apiUrl + '/jobs',
    UPLOAD_DOCUMENT: environment.apiUrl + '/documents/upload',
    DOWNLOAD_DOCUMENT: environment.apiUrl + '/documents/download',
    ADMIN_DOWNLOAD_DOCUMENT: environment.apiUrl + '/secure/documents/download',
    DELETE_DOCUMENT: environment.apiUrl + '/documents/delete',
    ADMIN_LIST_SELLERS: environment.apiUrl + '/secure/sellers',
    ADMIN_LOGISTIC_PARTNERS: environment.apiUrl + '/secure/logisticsPartners',
    CLIENT_PARTNERS: environment.apiUrl + '/clientPartners',
    SECURE_CLIENT_PARTNERS: environment.apiUrl + '/secure/clientPartners',
    TESTIMONIALS: environment.apiUrl + '/testimonials',
    SECURE_TESTIMONIALS: environment.apiUrl + '/secure/testimonials',
    SALES_BASE_URL: environment.apiUrl + '/sales',
    ORDER_SHIPPING_PRICING: environment.apiUrl + '/order/shippingPricing',
    COMMON_METRICS: environment.apiUrl + '/common/metrics',
    AD_BANNERS_BASE_URL: environment.apiUrl + '/adBanners',
    DELETE_ACCOUNT: environment.apiUrl + '/user/delete-account',
    RESEND_LINK: environment.apiUrl + '/secure/users',
};

export const SECURE_API_URLS = {
    MEASUREMENT: environment.apiUrl + '/secure/measurement_units',
    LIST_OF_PRODUCTS_CONDITIONS: environment.apiUrl + '/secure/product_conditions',
    OUTBOX_BASE_URL: environment.apiUrl + '/secure/outbox',
    TEMPLATES_BASE_URL: environment.apiUrl + '/secure/templates',
    OFFERS_BASE_URL: environment.apiUrl + '/secure/offers',
    GROUPS_BASE_URL: environment.apiUrl + '/secure/groups',
    BLOGS_BASE_URL: environment.apiUrl + '/secure/blogs',
    ORDERS_BASE_URL: environment.apiUrl + '/secure/orders',
    LINE_OFFERS_BASE_URL: environment.apiUrl + '/secure/lineOffers',
    JOBS_BASE_URL: environment.apiUrl + '/secure/jobs',
    SUBSCRIPTIONS_BASE_URL: environment.apiUrl + '/secure/subscriptions',
    USERS_SEARCH_BASE_URL: environment.apiUrl + '/secure/users/search-eFarms',
    AD_BANNERS_BASE_URL: environment.apiUrl + '/secure/adBanners',
};

export const ADMIN_API_URLS = {
    PAYMENTS_PATH: environment.apiUrl + '/secure/payments'
};

export const EXT_URLS = {
    FIXER_CURRENCY_EXCHANGE: `http://data.fixer.io/api/latest?access_key=${environment.fixerKey}`,
    EXCHANGE_RATE_API_URL: `https://v6.exchangerate-api.com/v6/${environment.exchangeRateApiKey}/pair`
};

